module.exports = __webpack_public_path__ + "static/GrayGminaMiastaChoczewo-f07e9612d8d35fcdaae35fa22fc68198.svg";